import {ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {NavigationService} from '../services/ionic/navigation.service';
import {ContractorService} from '../services/contractor.service';
import {routeUrls} from '../constants/route-urls';

export const backendGuard: CanActivateFn | CanActivateChildFn = async (activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Promise<boolean> => {
  const contractorService: ContractorService = inject(ContractorService);
  const navigationService: NavigationService = inject(NavigationService);

  const hasBackend: boolean = contractorService.hasBackend;

  if (hasBackend) {
    return true;
  } else {
    navigationService.navigateRootBack(routeUrls.addContractor).catch((err: any): void => {
      throw err;
    });

    return false;
  }
};
